const landingPageSeo = {
    '/color-theme': 'colorTheme',
    '/dominant-image-colors': 'dominantImageColors',
    '/color-harmonies': 'colorHarmonies',
    '/color-details': 'colorDetails',
    '/color-style-guide': 'colorStyleGuide',
    '/color-wheel': 'colorWheel',
    '/color-mixer': 'colorMixer',
    '/tints-and-shades': 'tintsAndShades',
    '/lighten-and-darken': 'lightenAndDarken',
    '/color-tones': 'colorTones',
};

export default landingPageSeo;
